import { useSearchParams } from "react-router-dom";
import { Button } from "primereact/button";
import { useMutation, useQuery } from "@tanstack/react-query";

import { requests } from "../../services/http-common";
import { useToast } from "../../Providers/ToastProvider";
import logo from "../../assets/images/logo2.png";

import styles from "./StatusLead.module.scss";
import moment from "moment";
import { useState } from "react";
import { DenyReasonPopup } from "../Sales/SalesLead/LeadList/Columns/DenyReasonPopup/DenyReasonPopup";

enum StatusType {
  Approved = "APPROVED",
  Deined = "DENIED",
}

interface LeadInfo {
  estimatedStartDate: string;
  laborGoalHours: number;
  laborGoalBudget: number;
  depositAmount: number;
  status: StatusType; // Only "APPROVED" or "DENIED" allowed
}

export function StatusLead() {
  const [params] = useSearchParams();

  const leadId = params.get("leadId");

  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [showReasonPopup, setShowReasonPopup] = useState<boolean>(false);

  const { show } = useToast();
  const { data, isLoading } = useQuery<LeadInfo>({
    queryKey: [`status-lead`],
    queryFn: () => {
      return requests.get(`/lead/info/${leadId}`);
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response?.data?.error?.message || "Something went wrong ",
      });
    },
    retry: false,
  });

  const sendStatus = useMutation({
    mutationFn: (data: any) => {
      return requests.post(`/lead/changeStatus/${leadId}`, { ...data });
    },
    onSuccess: () => {
      setIsSuccess(true);
      show({ detail: "Status changed" });
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response?.data?.error?.message || "Something went wrong ",
      });
    },
    onSettled: () => {
      setShowReasonPopup(false);
    },
  });

  if (!data) {
    return null;
  }

  const isExpired =
    data.status === StatusType.Approved || data.status === StatusType.Deined;

  return (
    <>
      <div className={styles.container}>
        <img className={styles.logo} src={logo} alt="logo" />
        {!isExpired ? (
          <div className={styles.info}>
            <p>
              We are excited to inform you that you have been added to our DCS
              Web App. We are working on your proposal and will have it to you
              shortly.
            </p>
            <p>Please review the details of the sales lead below:</p>
            <ul>
              <li>
                Estimated start date:{" "}
                {moment(data.estimatedStartDate).format("MM/DD/YYYY")}
              </li>
              {/* <li>Deposit amount: {data.depositAmount}</li>
              <li>Labor goal budget: {data.laborGoalBudget}</li>
              <li>Labor goal hours: {data.laborGoalHours}</li> */}
            </ul>
            <p>
              To approve the sales lead, simply click on the "Approve" button
              below. To deny the lead, click on the "Deny" button.{" "}
            </p>

            <div className={styles.buttons}>
              <Button
                disabled={sendStatus.isLoading || isLoading || isSuccess}
                label="Deny"
                aria-label="create-lead"
                className="p-button-outlined p-button-secondary"
                onClick={() => setShowReasonPopup(true)}
              />
              <Button
                disabled={sendStatus.isLoading || isLoading || isSuccess}
                label="Approve"
                aria-label="create-lead"
                className="p-button-sm"
                style={{ background: "#45503F" }}
                onClick={() =>
                  sendStatus.mutate({ status: StatusType.Approved })
                }
              />
            </div>
          </div>
        ) : (
          <h2>This Link is expired</h2>
        )}
      </div>
      {showReasonPopup ? (
        <DenyReasonPopup
          onHide={() => setShowReasonPopup(false)}
          updateLeadStatus={sendStatus}
        />
      ) : null}
    </>
  );
}
